import type { MenuVersionsItemsProps } from '@/interface/Menu';
import type { FC } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
export const MenuSectionTitle: FC<MenuSectionTitleProps> = ({
  isMenuOpen,
  name
}) => <Flex display={isMenuOpen ? 'flex' : 'none'} w="full" my="4" data-sentry-element="Flex" data-sentry-component="MenuSectionTitle" data-sentry-source-file="Separator.tsx">
    <Text fontWeight="medium" lineHeight="1.1875rem" color="content.brand" data-sentry-element="Text" data-sentry-source-file="Separator.tsx">
      {name}
    </Text>
  </Flex>;
type MenuSectionTitleProps = Pick<MenuVersionsItemsProps, 'name'> & {
  isMenuOpen: boolean;
};